import React from 'react';

export const LucidSearchResultIcon = () => {
	return (
		<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
			<rect
				x="-115.5"
				y="-454.5"
				width="1941"
				height="891"
				rx="4.5"
				stroke="#9747FF"
				strokeDasharray="10 5"
			/>
			<rect width="32" height="32" rx="8" fill="#292A2E" />
			<path
				d="M8.0143 18.1416C8.0143 15.4564 8.02145 12.772 8.00572 10.0868C8.00358 9.70682 8.11652 9.49577 8.45677 9.30326C10.6727 8.0491 12.8737 6.76856 15.0796 5.49657C15.5192 5.24274 15.5414 5.25415 15.5414 5.75039C15.5414 11.0487 15.5414 16.347 15.5414 21.646C15.5414 21.7529 15.5485 21.8606 15.5407 21.9668C15.5214 22.2363 15.6164 22.2813 15.8459 22.1465C16.5336 21.7437 17.2262 21.3487 17.9167 20.9508C19.4629 20.0596 21.0091 19.1676 22.5559 18.2771C22.9226 18.066 22.9641 18.0895 22.9641 18.5216C22.9655 21.0043 22.9655 23.4876 22.9641 25.9703C22.9641 26.4309 22.9369 26.4573 22.4802 26.458C20.2885 26.4616 18.0969 26.4566 15.9059 26.4723C15.5507 26.4751 15.4263 26.3739 15.4334 26.0088C15.4549 24.9636 15.442 23.9183 15.4406 22.8723C15.4406 22.4994 15.4334 22.4923 15.1053 22.6812C12.8872 23.9561 10.6713 25.2352 8.45248 26.5093C8.33525 26.5764 8.21588 26.7304 8.07291 26.6377C7.95568 26.5621 8.01501 26.3945 8.01501 26.2683C8.01287 23.5597 8.01287 20.851 8.01287 18.1423L8.0143 18.1416Z"
				fill="white"
			/>
		</svg>
	);
};
